import { useState } from "react";
import Card from "@/components/base/Card";
import Badge from "@/components/base/Badge";
import Input from "@/components/base/Input";
import Button from "@/components/base/Button";

export default function ProfesorJefeHistorialPage() {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("todos");

  const headers = [
    "Fecha Envío", "Estudiante", "Formulario", "Destinatario", "Estado de Recepción"
  ];

  const rawRows = [
    [
      "2026-06-08", "Bastián Tapia", "Cuestionario Conductual", "Convivencia Escolar", "Badge:activo:Aceptado"
    ],
    [
      "2026-05-24", "Cristóbal Leiva", "Bitácora Pedagógica", "Orientadora", "Badge:activo:Aceptado"
    ],
    [
      "2026-04-18", "Carolina Paz", "Pauta de Adaptación", "Psicóloga", "Badge:activo:Aceptado"
    ]
  ];

  const filtered = rawRows.filter(row => {
    const textMatch = row.some(cell => String(cell).toLowerCase().includes(search.toLowerCase()));
    if (!textMatch) return false;
    
    if (filter === "todos") return true;
    
    // Find status value in row
    return row.some(cell => String(cell).toLowerCase() === filter.toLowerCase() || String(cell).toLowerCase().includes('badge:') && String(cell).toLowerCase().includes(filter.toLowerCase()));
  });

  const getStatusVariant = (statusText) => {
    const st = statusText.toLowerCase();
    if (st.includes("activo") || st.includes("completado") || st.includes("aceptado") || st.includes("leido") || st.includes("vigente") || st.includes("abierto") || st.includes("alta")) return "primary";
    if (st.includes("pendiente") || st.includes("evaluacion") || st.includes("revision") || st.includes("proceso") || st.includes("media")) return "warning";
    if (st.includes("vencido") || st.includes("critico") || st.includes("urgente") || st.includes("rechazado") || st.includes("incumplida")) return "danger";
    return "neutral";
  };

  return (
    <div className="p-4 md:p-6 space-y-5 animate-fade-in-up">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Historial de Informes Enviados</h1>
          <p className="text-sm text-foreground-500 mt-0.5">Registro de todos los cuestionarios y reportes docentes enviados a orientación y convivencia.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" className="cursor-pointer">
            <i className="ri-download-line mr-1.5" /> Exportar
          </Button>
          <Button size="sm" className="cursor-pointer bg-primary-500 text-white">
            <i className="ri-add-line mr-1.5" /> Agregar Registro
          </Button>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center justify-between">
        <Input
          placeholder="Buscar..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          icon={<i className="ri-search-line" />}
          className="max-w-sm"
          fullWidth={false}
        />
        <div className="flex gap-2 overflow-x-auto">
          {["todos", "activo", "pendiente", "critico"].map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold border cursor-pointer capitalize transition-all ${
                filter === f
                  ? "bg-foreground-900 text-white border-foreground-900"
                  : "bg-white text-foreground-600 border-background-200 hover:bg-background-50"
              }`}
            >
              {f === "todos" ? "Todos" : f === "critico" ? "⚠️ Críticos" : f}
            </button>
          ))}
        </div>
      </div>

      <Card padding="none">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-50/50">
                <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Fecha Envío</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Estudiante</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Formulario</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Destinatario</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Estado de Recepción</th>
                <th className="text-right py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((row, idx) => (
                <tr key={idx} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                  {row.map((cell, cidx) => {
                    if (cidx === 0) {
                      return (
                        <td key={cidx} className="py-3.5 px-4 font-semibold text-foreground-900 whitespace-nowrap">
                          {cell}
                        </td>
                      );
                    }
                    if (cell.startsWith("Badge:")) {
                      const txt = cell.replace("Badge:", "");
                      return (
                        <td key={cidx} className="py-3.5 px-4 whitespace-nowrap">
                          <Badge variant={getStatusVariant(txt)}>{txt}</Badge>
                        </td>
                      );
                    }
                    return (
                      <td key={cidx} className="py-3.5 px-4 text-foreground-600 whitespace-nowrap text-xs">
                        {cell}
                      </td>
                    );
                  })}
                  <td className="py-3.5 px-4 text-right whitespace-nowrap">
                    <button className="text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer p-1">
                      <i className="ri-eye-line text-base" />
                    </button>
                    <button className="text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer p-1 ml-1.5">
                      <i className="ri-edit-line text-base" />
                    </button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr>
                  <td colSpan={headers.length + 1} className="py-12 text-center text-foreground-400">
                    No se encontraron registros que coincidan con la búsqueda.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
